module.exports = __webpack_public_path__ + "static/media/biotake.b8a9d97c.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/images/experiences/biotake.PNG
// module id = 99
// module chunks = 0